import { createFeatureSelector, createSelector } from '@ngrx/store';

import { paymentProfilesAdapter, paymentProfilesFeatureKey, ProfilesEntityState } from './profiles.reducer';

const { selectAll, selectEntities, selectIds } = paymentProfilesAdapter.getSelectors();

const selectState = createFeatureSelector<ProfilesEntityState>(paymentProfilesFeatureKey);

export const selectPaymentProfilesList = createSelector(selectState, (state) => selectAll(state));
export const selectPaymentProfilesMap = createSelector(selectState, (state) => selectEntities(state));
export const selectPaymentProfilesIds = createSelector(selectState, (state) => selectIds(state));

export const selectLoading = createSelector(selectState, (state) => state.loading);

export const selectLoaded = createSelector(selectState, (state) => state.loaded);

export const selectError = createSelector(selectState, (state) => state.error);

export const selectLoadError = createSelector(selectState, (state) => state.loadError);

export const selectIdsInProgress = createSelector(selectState, (state) => state.idsInProgress);

export const selectPageParams = createSelector(selectState, (state) => state.pageParams);

export const selectTotalElements = createSelector(selectState, (state) => state.totalElements);
